




























































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Input } from "ant-design-vue";
import CSendCode from "@/components/CSendCode/index.vue";

@Component({
  name: "Login",
  components: {
    CSendCode,
    AInput: Input,
    AInputPassword: Input.Password
  }
})
export default class Login extends Base {
  private username = "";
  private password = "";
  private uuid = "";
  private code = "";
  private loginType = this.$enums.LoginType.code;

  private created() {
    // 清楚后台管理系统的cookie
    this.$tools.delCookie("Admin-Token");

    this.setUser();
    sessionStorage.clear();
    localStorage.clear();
    // const errmsg: string = (this.$route.query.errmsg ? this.$route.query.errmsg : "") as string;
    // if (errmsg) {
    //   this.$message.error(decodeURIComponent(errmsg));
    //   const query: any = { ...this.$route.query };
    //   delete query.errmsg;
    //   query.t = new Date().getTime().toString();
    //   this.$nextTick(() => {
    //     this.$router.replace({ name: "Login", query: query });
    //   });
    // }
    // this._logout();
  }

  /**
   * 账号密码登录前验证
   */
  private beforePwd() {
    this.$message.destroy();
    if (!this.username) {
      this.$message.error("请输入账号");
      return false;
    }

    if (!this.password) {
      this.$message.error("请输入密码");
      return false;
    }

    return true;
  }

  /**
   * 验证码登录前验证
   */
  private beforeCode() {
    this.$message.destroy();
    if (!this.username) {
      this.$message.error("请输入手机号");
      return false;
    }

    if (!this.$tools.checkPhone(this.username)) {
      this.$message.error("您的手机号码格式不正确");
      return false;
    }

    if (!this.uuid) {
      this.$message.error("请先发送验证码");
      return false;
    }

    if (!this.code) {
      this.$message.error("请输入验证码");
      return false;
    }

    return true;
  }

  /**
   * 密码登录
   */
  private async byPwd() {
    if (this.beforePwd()) {
      const res = await this.$api.Login({
        username: this.username,
        password: this.password,
        token: false
      });
      return Promise.resolve(res);
    } else {
      return Promise.resolve(false);
    }
  }

  /**
   * 验证码登录
   */
  private async byCode() {
    if (this.beforeCode()) {
      const res = await this.$api.LoginByCode({
        phonenumber: this.username,
        code: this.code,
        uuid: this.uuid,
        token: false
      });
      return Promise.resolve(res);
    } else {
      return Promise.resolve(false);
    }
  }

  /**
   * 登录事件入口
   */
  private async login() {
    let res: any = null;
    if (this.loginType === this.$enums.LoginType.pwd) {
      res = await this.byPwd();
    } else {
      res = await this.byCode();
    }

    if (res && res.code === 200) {
      localStorage.setItem("token", res.token);
      await this.updateUser(true);
      this.$router.replace({ name: "Home" });
    }
  }

  /**
   * 发送完短信验证码后的回调函数，用来获取接口返回的相关数据
   */
  private getCodeInfo(obj: any) {
    this.uuid = obj.uuid;
  }

  private changeLoginType() {
    if (this.loginType === this.$enums.LoginType.pwd) {
      this.loginType = this.$enums.LoginType.code;
    } else {
      this.loginType = this.$enums.LoginType.pwd;
    }

    // this.username = "";
    this.password = "";
    this.code = "";
    this.uuid = "";
  }
}
